module.exports = "mutation DeleteProviderComment($commentId:ID!){deleteComment:deleteProviderComment(commentId:$commentId){success}}"